<template lang="pug">
  .columns
    .column(v-for="group,key in info" :key="key")
      .panel
        .panel-heading {{ group.group }}

        .panel-block.is-block(v-for="option,key in group.data" :key="key")
          .is-pulled-right
            b-taglist(attached)
              b-tag.is-primary {{ option.value }}
              b-tag.is-info(v-if="option.percentage") {{ option.percentage.toFixed(option.percentage > 1 ? 0 : 1) }}%
          span {{option.label}}

</template>

<script>
export default {
  name: "platform-info",

  props: {
    info: Object,
  },
};
</script>
